export default __webpack_public_path__ + "static/media/817w2.d87bcfe4.png";